import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { EditorState } from "IDE/enums";
import { identifyEntityFromPath } from "navigation/FocusEntity";
export const useCurrentPackageState = () => {
  const [packageState, setPackageState] = useState(EditorState.EDITOR);
  const { pathname } = useLocation();
  const entityInfo = identifyEntityFromPath(pathname);

  useEffect(
    function updatePackageState() {
      setPackageState(entityInfo.appState);
    },
    [entityInfo.appState],
  );

  return packageState;
};
